<div class="floating-label">
    <div class="password-input-wrapper">
        <input [formControlName]="controlName" [id]="inputId" [type]="showPassword ? 'text' : 'password'" [class]="inputClass" [attr.placeholder]="placeholderText | translate" [readOnly]="readonly" [ngClass]="{ 'no-icon': !showIcon }" autocomplete="off" />
        <span class="password-eye-icon" (click)="togglePasswordVisibility()">
            <i class="bi" [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'"> </i>
        </span>
    </div>
    <label-extended-control [labelText]="labelText"> </label-extended-control>
    <div *ngIf="showIcon" class="icon" (click)="togglePasswordVisibility()">
        <span [class]="iconClass"></span>
    </div>
    <field-error-display-control [displayError]="parentFormHelper.showFieldError(controlName)" [errorMsg]="parentFormHelper.getErrorMessageHtml(controlName)"> </field-error-display-control>
</div>
